import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const partieBadges = {
  fr: {
    1: { nom: 'PARTIE I – STRATÉGIE DE MARCHÉ', color: '#8b5cf6', total: 4 },
    2: { nom: 'PARTIE II – INFRASTRUCTURE TECHNOLOGIQUE', color: '#06b6d4', total: 3 },
    3: { nom: 'PARTIE III – PLAN D\'EXÉCUTION', color: '#fb923c', total: 3 },
    4: { nom: 'PARTIE IV – MODÈLE FINANCIER', color: '#a8d530', total: 7 }
  },
  en: {
    1: { nom: 'PART I – MARKET STRATEGY', color: '#8b5cf6', total: 4 },
    2: { nom: 'PART II – TECHNOLOGICAL INFRASTRUCTURE', color: '#06b6d4', total: 3 },
    3: { nom: 'PART III – EXECUTION PLAN', color: '#fb923c', total: 3 },
    4: { nom: 'PART IV – FINANCIAL MODEL', color: '#a8d530', total: 7 }
  }
};

const pageToPartie = {
  '/': { partie: 1, page: 1 },
  '/marche': { partie: 1, page: 2 },
  '/marche-garderies': { partie: 1, page: 3 },
  '/vision': { partie: 1, page: 4 },
  '/produit': { partie: 2, page: 1 },
  '/propriete-intellectuelle': { partie: 2, page: 2 },
  '/paiements': { partie: 2, page: 3 },
  '/plan-execution': { partie: 3, page: 1 },
  '/gtm': { partie: 3, page: 2 },
  '/roadmap': { partie: 3, page: 3 },
  '/resume-executif': { partie: 4, page: 1 },
  '/modele': { partie: 4, page: 2 },
  '/organisation': { partie: 4, page: 3 },
  '/valorisation': { partie: 4, page: 4 },
  '/levee-de-fonds': { partie: 4, page: 5 },
  '/synthese-investisseur': { partie: 4, page: 6 },
  '/previsions': { partie: 4, page: 7 }
};

export default function PartieBadge({ path }) {
  const { language } = useLanguage();
  const info = pageToPartie[path];
  if (!info) return null;
  
  const badge = partieBadges[language][info.partie];
  
  return (
    <div className="mb-4 flex items-center gap-2 text-sm">
      <span 
        className="w-3 h-3 rounded-sm"
        style={{ backgroundColor: badge.color }}
      ></span>
      <span 
        className="font-semibold"
        style={{ color: badge.color }}
      >
        {badge.nom}
      </span>
      <span className="text-gray-500 ml-2">{language === 'fr' ? `Page ${info.page} de ${badge.total}` : `Page ${info.page} of ${badge.total}`}</span>
    </div>
  );
}
